<section>
    <h1 class="header">{{ pageData.pageTitle }}</h1>
    <div class="progress-block">
        <h3 class="progress-header" id="success-head">{{ pageData.header }}</h3>
        <div class="shadow-circle" *ngIf="pageData.fiveGIcon && !isBillPreviewEnabled">
            <xm-media-image class="logo" [imageOptions]="icon" size="height"></xm-media-image>
        </div>
        <p class="description">{{ pageData.subhead }}</p>
        <cms-text
            class="description" *ngIf="isBillPreviewEnabled" [originalText]="pageData.description"
        ></cms-text>
        <button class="xm-btn-primary-light btn" (click)="endLevelMoveFlow()">{{ pageData.cta }}</button>
    </div>
</section>
